export enum EventKey {
  CLOSE = 'close',
  SUCCESS = 'success',
  PLAY_VIDEO = 'play-video',
  CONFIG_CHANGE = 'config-option-select-change',
}
